import React from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "../context/PermissionContext";

/**
 * ProtectedRoute
 * --------------
 * Wrap any dashboard <Route> element with this component.
 *
 * Usage:
 *   <ProtectedRoute pageKey="freight-form">
 *     <PaddedRoute><FreightForm /></PaddedRoute>
 *   </ProtectedRoute>
 *
 * - If user is admin      → renders children normally
 * - If user has access    → renders children normally
 * - If user lacks access  → redirects to /dashboard/access-denied
 *
 * pageKey must match one of the string keys defined in the page-key table.
 * If pageKey is not provided the route is always accessible (for internal/util routes).
 */
function ProtectedRoute({ pageKey, children }) {
  const { canAccess } = usePermission();

  // No pageKey means it's an unguarded internal route (e.g., edit/:id variants)
  if (!pageKey) return children;

  if (!canAccess(pageKey)) {
    return <Navigate to="/dashboard/access-denied" replace />;
  }

  return children;
}

export default ProtectedRoute;
